const dashboard = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/system/home/Home.vue'),
    meta: {
      layout: 'content',
    },
  },
]

export default dashboard
